type FieldTranslation = {
  label: string;
  placeholder: string;
};

export type PersonalDataTranslations = {
  heading: string;
  areasHeading: string;
  areasDescription: string;
  checkboxText: string;
  areasSelection: {
    instruction: string;
    proceed: string;
  };
  areasPrioritization: {
    instruction: string;
    backToSelection: string;
  };
  fields: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    fieldOfStudy: string;
    graduationYear: FieldTranslation;
    studentStatus: string;
    universityName: string;
    location: FieldTranslation;
    typeOfStudy: string;
    aboutYourself: FieldTranslation;
    areaDescription: FieldTranslation;
    isUnder30: string;
    linkedinUrl: string;
    githubUrl: string;
    notRequired: string;
    required: string;
  };
  graduationYearOptions: {
    placeholder: string;
    '2': string;
    '3': string;
    '4': string;
    '5': string;
    '6': string;
  };
  button: {
    next: string;
    back: string;
  };
  errors: {
    phoneNumberMin: string;
  };
  dropdown: {
    search: string;
    noResults: string;
  };
  university: {
    addCustom: string;
    selectFromList: string;
  };
};

export const personalDataTranslations: PersonalDataTranslations = {
  heading: 'Podaj nam kilka informacji o sobie',
  areasHeading: 'Obszary, do których chcę aplikować',
  areasDescription: 'Wybierz maksymalnie 3 obszary i ustaw im priorytety',
  checkboxText: 'Oświadczam, że zapoznałem(-am) się z regulaminem i akceptuję jego warunki.',
  areasSelection: {
    instruction: 'Wybierz obszary, które Cię najbardziej interesują:',
    proceed: 'Przejdź do ustalania priorytetów',
  },
  areasPrioritization: {
    instruction: 'Przeciągnij obszary, aby ustalić ich kolejność (1 = najwyższy priorytet):',
    backToSelection: '← Powrót do wyboru',
  },
  fields: {
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phoneNumber: 'Numer telefonu (same cyfry)',
    fieldOfStudy: 'Kierunek studiów',
    graduationYear: { label: 'Rok studiów / absolwent(-ka)', placeholder: 'Ukończony rok studiów' },
    studentStatus: 'Status',
    universityName: 'Nazwa uczelni',
    location: { label: 'Miasto', placeholder: 'Lokalizacja, w której chcesz odbywać praktykę' },
    typeOfStudy: 'Rodzaj studiów',
    aboutYourself: {
      label: 'Powiedz nam coś o sobie',
      placeholder:
        'To jest miejsce dla Ciebie, powiedz co Cię motywuje, pochwal się osiągnięciami lub udziałem w projektach',
    },
    areaDescription: {
      label: 'Obszar biznesowy',
      placeholder: 'Daj nam znać, który obszar jest Ci najbliższy i dlaczego?',
    },
    isUnder30: 'Potwierdzam, że mam mniej niż 30 lat',
    linkedinUrl: 'Link do LinkedIn',
    githubUrl: 'Link do GitHub lub portfolio',
    notRequired: 'Opcjonalnie',
    required: 'pole obowiązkowe',
  },
  graduationYearOptions: {
    placeholder: 'Rok studiów / absolwent(-ka)',
    '2': 'Rok 2',
    '3': 'Rok 3',
    '4': 'Rok 4',
    '5': 'Rok 5',
    '6': 'Absolwent do 30 r.ż',
  },
  button: {
    back: 'Wstecz',
    next: 'Dalej',
  },
  errors: {
    phoneNumberMin: 'Numer telefonu musi mieć min. 9 cyfr',
  },
  dropdown: {
    search: 'Szukaj...',
    noResults: 'Brak wyników',
  },
  university: {
    addCustom: 'Dodaj własną:',
    selectFromList: 'Wybierz z listy powyżej',
  },
};
